import { Col, Row, Form, Input, Button, Divider, Select, Tooltip } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { Upload, Accordion, AddButton } from 'components';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { USUARIOS_FISCALIZACION } from 'constants/nombresCatalogos';
import { useSelector } from 'react-redux';
import './ServidoresPublicos.scss';
import { useEffect, useState } from 'react';
import * as fieldMsgs from 'constants/formFieldsMessages';

const ServidoresPublicos = ({ form, loadingImages, servidores }) => {
  const firmantes = useSelector(selectCatalogByName(USUARIOS_FISCALIZACION));
  const [dataServidoresPub, setDataServidoresPub] = useState([]);
  const [servidoresPublicos, setServidoresPublicos] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleServidoresPublicos = () => {
    let informacionServidoresPublicos = [];
    if (firmantes?.length !== 0) {
      informacionServidoresPublicos = firmantes.map((sp) => {
        const informacionServidorPublico = {};
        informacionServidorPublico.id = sp.idUsuario;
        if (sp.numEmpleado === null) {
          informacionServidorPublico.nombre = `${sp.nombre}${sp.apPaterno}${sp.apMaterno}${'/'}${
            sp.puesto
          }`;
        } else {
          informacionServidorPublico.nombre = `${sp.numEmpleado}${'/'}${sp.nombre}${sp.apPaterno}${
            sp.apMaterno
          }${'/'}${sp.puesto}`;
        }
        return informacionServidorPublico;
      });
    }
    setDataServidoresPub(informacionServidoresPublicos);
  };

  const handleChangeServidores = (value) => {
    setSelectedIds([value]);
    const newSelectedIds = [];
    const { fiscalizacion } = form.getFieldsValue(['fiscalizacion']);
    fiscalizacion.forEach((f) => {
      if (f !== null && f !== undefined) {
        newSelectedIds.push(f.servidorPublicoId);
      }
    });
    setSelectedIds(newSelectedIds);
  };

  const addServidorPublicoManual = (_, idx) => {
    const { fiscalizacion } = form.getFieldsValue(['fiscalizacion']);
    const updatedServidorPublico = {
      ...fiscalizacion[idx],
      servidorPublicoId: 0,
      numEmpleado: '',
      nombre: '',
      apPaterno: '',
      apMaterno: '',
      puesto: '',
      cargoAutoriza: '',
      numeroConstancia: ''
    };
    const updatedServidorPublicoList = [...fiscalizacion];
    updatedServidorPublicoList[idx] = updatedServidorPublico;
    form.setFieldsValue({
      fiscalizacion: updatedServidorPublicoList
    });
    setServidoresPublicos(updatedServidorPublicoList);
  };

  const setServidoresForm = (fisca) => {
    setServidoresPublicos(fisca);
    const newSelectedIds = [];

    fisca.forEach((f) => {
      if (f !== null && f !== undefined) {
        newSelectedIds.push(f.servidorPublicoId);
      }
    });
    setSelectedIds(newSelectedIds);
  };

  useEffect(() => {
    const { fiscalizacion } = form.getFieldsValue(['fiscalizacion']);
    if (fiscalizacion.length > 0) {
      setServidoresForm(fiscalizacion);
    }
    handleServidoresPublicos();
  }, [servidoresPublicos, servidores, form, form.getFieldValue('fiscalizacion')]);

  const formComponent = ({ remove, field, index, isLastServPublico }) => (
    <div>
      <div className="servidoresPublicos">
        <Row gutter={24}>
          <Col span={12} className="servidoresPublicos-tabla-header">
            <span className="requerido">*</span>Información general:
          </Col>
          <Col span={3} className="servidoresPublicos-tabla-header">
            <span className="requerido">*</span>Identificación anverso:
          </Col>
          <Col span={3} className="servidoresPublicos-tabla-header">
            <span className="requerido">*</span>Identificación reverso:
          </Col>
          <Col span={3} className="servidoresPublicos-tabla-header">
            <span className="requerido">* </span>Firma digital:
          </Col>
          <Col span={3} style={{ textAlign: 'center' }} className="servidoresPublicos-tabla-header">
            Acciones
          </Col>
        </Row>
        <div className="container-infoServidorPublico">
          <div className="info-servidorPublico">
            <div className="selectorServidorPublico">
              {servidoresPublicos[index]?.servidorPublicoId === 0 ? (
                <>
                  <div className="servidorPublico-nombre">
                    <Form.Item
                      name={[field.name, 'numEmpleado']}
                      label="Número de empleado:"
                      Key={index}
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input
                        style={{
                          width: 180
                        }}
                        maxLength={50}
                        placeholder="Escribe"
                      />
                    </Form.Item>
                    <Form.Item
                      name={[field.name, 'nombre']}
                      label="Nombre (s):"
                      Key={index}
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input
                        style={{
                          width: 200
                        }}
                        maxLength={50}
                        placeholder="Escribe"
                      />
                    </Form.Item>
                    <Form.Item
                      className=""
                      name={[field.name, 'apPaterno']}
                      label="Primer apellido:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input
                        key={index}
                        style={{
                          width: 200
                        }}
                        maxLength={50}
                        placeholder="Escribe"
                      />
                    </Form.Item>
                  </div>
                  <div className="servidorPublico-puesto">
                    <Form.Item name={[field.name, 'apMaterno']} label="Segundo apellido:">
                      <Input
                        key={index}
                        style={{
                          width: 200
                        }}
                        maxLength={50}
                        placeholder="Escribe"
                      />
                    </Form.Item>
                    <Form.Item
                      name={[field.name, 'puesto']}
                      label="Puesto:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input
                        key={index}
                        style={{
                          width: 400
                        }}
                        maxLength={50}
                        placeholder="Escribe"
                      />
                    </Form.Item>
                  </div>
                  <div className="servidorPublico-cargo">
                    <Form.Item
                      name={[field.name, 'cargoAutoriza']}
                      label="Cargo de quien autoriza el monitoreo:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input style={{ width: 400 }} key={index} placeholder="Escribe" />
                    </Form.Item>
                    <Form.Item
                      name={[field.name, 'numeroConstancia']}
                      label="Numero de constancia:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input style={{ width: 200 }} key={index} placeholder="Escribe" />
                    </Form.Item>
                  </div>
                </>
              ) : (
                <>
                  <Form.Item
                    name={[field.name, 'servidorPublicoId']}
                    label="Servidor público:"
                    key={index}
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                    <Select
                      style={{
                        width: 400
                      }}
                      placeholder="Selecciona"
                      options={dataServidoresPub.map((option) => ({
                        ...option,
                        disabled: selectedIds.includes(option.id)
                      }))}
                      fieldNames={{
                        value: 'id',
                        label: 'nombre'
                      }}
                      filterOption={(inputValue, option) =>
                        option.nombre?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      showSearch
                      onChange={handleChangeServidores}
                    />
                  </Form.Item>
                  <Tooltip title="Agregar servidor público">
                    <Button
                      className="add-servidorPublicoManual"
                      shape="square"
                      icon={<PlusOutlined className="plus-icon" />}
                      onClick={(e) => addServidorPublicoManual(e, index)}
                    />
                  </Tooltip>
                  <div className="servidorPublico-cargo">
                    <Form.Item
                      name={[field.name, 'cargoAutoriza']}
                      label="Cargo de quien autoriza el monitoreo:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input style={{ width: 400 }} key={index} placeholder="Escribe" />
                    </Form.Item>
                    <Form.Item
                      name={[field.name, 'numeroConstancia']}
                      label="Numero de constancia:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input style={{ width: 200 }} key={index} placeholder="Escribe" />
                    </Form.Item>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="container-imagenes">
            <Form.Item
              required
              name={[field.name, 'identAnverso']}
              className="column-acciones-identAnverso"
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaCierreIdentAnversoSP"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <Form.Item
              required
              name={[field.name, 'identReverso']}
              className="hallazgos-imagenes-identReverso"
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaCierreIdentReversoSP"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <Form.Item
              required
              name={[field.name, 'firma']}
              className="hallazgos-imagenes-firma"
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaCierreFirmaSP"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <div className="formulario-servidorPublico-accioness">
              <Button key={index} disabled={isLastServPublico} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(field.name)} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="formulario-servidoresPublicos">
      <Form layout="vertical" form={form}>
        <Form.List name="fiscalizacion" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map((field, index) => {
                  const isLastServPublico = fields.length <= 1;

                  const servidorPublico = {
                    key: `servidor_${index}`,
                    label: `Servidor público ${index + 1}`,
                    forceRender: true,
                    children: formComponent({
                      remove,
                      field,
                      index,
                      isLastServPublico
                    })
                  };
                  return <Accordion items={[servidorPublico]} defaultActiveKey={['servidor_0']} />;
                })}
                <Divider />
                <div className="servidorPublico-btn">
                  <AddButton style={{ marginRight: '2em' }} onClick={() => add()}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

export default ServidoresPublicos;

ServidoresPublicos.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    scrollToField: PropTypes.func,
    getFieldValue: PropTypes.func
  }).isRequired,
  loadingImages: PropTypes.bool,
  servidores: PropTypes.arrayOf(PropTypes.shape({}))
};

ServidoresPublicos.defaultProps = {
  loadingImages: false,
  servidores: []
};
